import React, { useState } from 'react';
import MyRafflesPage from './MyRafflesPage';
import RaffleSettingsPage from './RaffleSettingsPage';
import './RafflePage.css';

type Tab = 'raffles' | 'settings';

export default function RafflePage() {
  const [activeTab, setActiveTab] = useState<Tab>('raffles');

  return (
    <div className="raffle-page">
      <div className="raffle-tabs">
        <button
          className={`raffle-tab ${activeTab === 'raffles' ? 'active' : ''}`}
          onClick={() => setActiveTab('raffles')}
        >
          🎰 My Raffles
        </button>
        <button
          className={`raffle-tab ${activeTab === 'settings' ? 'active' : ''}`}
          onClick={() => setActiveTab('settings')}
        >
          🎨 Design Settings
        </button>
      </div>

      <div className="raffle-content">
        {activeTab === 'raffles' && <MyRafflesPage />}
        {activeTab === 'settings' && <RaffleSettingsPage />}
      </div>
    </div>
  );
}
